import {Controls, ControlsItem, Typography} from '@genestack/ui';
import React, {FC} from 'react';

import {CommitDto} from '../../../../../../providers/version';
import {UserUnit} from './user-unit';
import {GlobalVersionData} from '../../../../../../hooks/global-version/use-global-version-query';
import {getFormattedDate} from '../../../../../../utils/format-date';
import {Link as LinkView} from '@genestack/ui';
import {Link} from 'wouter';

interface Props {
    documentRevision?: string;
    documentId: string;
    revisionInfo: CommitDto;
    selectedGlobalVersion: GlobalVersionData;
}

export const DocFooterInfo: FC<Props> = ({
    revisionInfo,
    documentId,
    documentRevision,
    selectedGlobalVersion
}) => {
    const {revision, author, createdAt} = revisionInfo;
    const username = author.name ?? author.email;
    const globalVersionVisibility = documentRevision === revision;

    return (
        <Controls
            gap={4} // tslint:disable-line: no-magic-numbers
        >
            <ControlsItem>
                <UserUnit username={username} />
            </ControlsItem>
            <ControlsItem>
                <LinkView as={Link} {...{to: `/${documentId}/revisions/${revision}`}}>
                    {getFormattedDate({
                        date: createdAt,
                        showTime: true
                    })}
                </LinkView>
                {globalVersionVisibility && (
                    <Typography as="span" intent="quiet">
                        {' / '}
                        {selectedGlobalVersion.label}
                    </Typography>
                )}
            </ControlsItem>
        </Controls>
    );
};
